import Enums from "../../../enums/enums";
const state = {
  setForgotPwdLoadingStatusType: Enums.LoadingStatusType.None,
  forgotPwd: null,
  getForgotPwdLoadingStatusType: Enums.LoadingStatusType.None,
  resetPwdLoadingStatusType: Enums.LoadingStatusType.None,
  resetPwdStatus: null,
};

const getters = {
  GetSetForgotPwdLoadingStatusType: (state) => {
    return state.setForgotPwdLoadingStatusType;
  },
  GetForgotPwd: (state) => {
    return state.forgotPwd;
  },
  GetForgotPwdLoadingStatusType: (state) => {
    return state.getForgotPwdLoadingStatusType;
  },
  GetResetPwdLoadingStatusType: (state) => {
    return state.resetPwdLoadingStatusType;
  },
  GetResetPwdStatus: (state) => {
    return state.resetPwdStatus;
  },
};
export { getters, state };
